import { render, staticRenderFns } from "./ed-subject-builder-editor.component.vue?vue&type=template&id=cb347506&scoped=true&"
import script from "./ed-subject-builder-editor.component.ts?vue&type=script&lang=ts&"
export * from "./ed-subject-builder-editor.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-subject-builder-editor.component.scss?vue&type=style&index=0&id=cb347506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb347506",
  null
  
)

export default component.exports